import React from "react"
import FieldProto from "../proto/field-proto";
import {EntityType} from "../../gd/const/item";
import {CustomFieldScope} from "../../model2/custom-field/@const";

export type FieldManagementFormCFV1Props = {
    field           : FieldProto;
    onSubmit        : callback;
    isNewField?     : boolean;
    disableRequired?: boolean
    entity?         : EntityType

    scope?          : CustomFieldScope[]
    mandatoryScope? : CustomFieldScope[]

    // className?  : string;
};

export default function FieldManagementFormCFV1(props:FieldManagementFormCFV1Props):any {

    return <props.field.renderComponents.managementFormCFV1 {...props} />

}